import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.inquiryDraft.deleteInquiryDraft;
export const deleteInquiryDraftIsLoadingSelector = (state: RootState) => getState(state).isLoading;
